import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models (F90M from 999_master_foxpro_schema.sql)
// ============================================================

export interface F90M {
  f90m_01: string;         // 資遣單號 (PK, auto-generated)
  f90m_11: string;         // 被資遣員工代號
  f90m_12: string | null;  // 通知日期
  f90m_13: string;         // 資遣事由（下拉選項）
  f90m_14: string;         // 資遣說明（備註）
  f90m_15: number;         // 年資（年.月格式）
  f90m_16: number;         // 本薪
  f90m_17: string | null;  // 預告日期
  f90m_18: number;         // 資遣費用（= 年資 × 本薪，可手改）
  f90m_19: string | null;  // 發放日期
  f90m_20: string;         // 入單人員代號
  f90m_21: string;         // 部門代號（由員工代號帶入）
  f90m_22: string;         // 職稱代號（由員工代號帶入）
  f90m_23: string | null;  // 到職日（由員工代號帶入）
  f90m_61: string;         // 單位主管核准 (Y/N/空)
  f90m_62: string;         // 單位主管代號
  f90m_63: string | null;  // 單位主管核准日期
  f90m_64: string;         // 單位主管核准說明
  f90m_66: string;         // 人事主管核准 (Y/N/空)
  f90m_67: string;         // 人事主管代號
  f90m_68: string | null;  // 人事主管會簽日期
  f90m_69: string;         // 人事主管核准說明
  f90m_71: string;         // 副總核准 (Y/N/空)
  f90m_72: string;         // 副總代號
  f90m_73: string | null;  // 副總核准日期
  f90m_74: string;         // 副總核准說明
  f90m_76: string;         // 總經理核准 (Y/N/空)
  f90m_77: string;         // 總經理代號
  f90m_78: string | null;  // 總經理核准日期
  f90m_79: string;         // 總經理核准說明
  f90m_80: string;         // 記錄狀態（"V"=有效）
  f90m_91: string;         // 建立人員
  f90m_92: string | null;  // 建立日期
  f90m_93: string;         // 最後修改人員
  f90m_151: number;
  f90m_152: number;
}

// ============================================================
// Request / Response types
// ============================================================

export interface PW9208ListResponse {
  data: F90M[];
  total: number;
  page: number;
  size: number;
}

export interface PW9208CreateRequest {
  master: Partial<F90M>;
}

// ============================================================
// API methods
// ============================================================

export const pw9208Api = {
  async list(page = 1, size = 20): Promise<PW9208ListResponse> {
    const res = await apiClient.get('/api/pw9208', { params: { page, size } });
    return res.data;
  },

  async search(keyword: string): Promise<PW9208ListResponse> {
    const res = await apiClient.get('/api/pw9208/search', { params: { keyword } });
    return res.data;
  },

  async get(id: string): Promise<F90M> {
    const res = await apiClient.get(`/api/pw9208/${encodeURIComponent(id)}`);
    return res.data;
  },

  async create(data: PW9208CreateRequest): Promise<F90M> {
    const res = await apiClient.post('/api/pw9208', data);
    return res.data;
  },

  async update(id: string, data: PW9208CreateRequest): Promise<F90M> {
    const res = await apiClient.put(`/api/pw9208/${encodeURIComponent(id)}`, data);
    return res.data;
  },

  async delete(id: string): Promise<void> {
    await apiClient.delete(`/api/pw9208/${encodeURIComponent(id)}`);
  },

  /** Lookup: employee, department */
  async lookupName(type: string, code: string): Promise<string> {
    if (!code || !code.trim()) return '';
    try {
      const res = await apiClient.get(
        `/api/pw9208/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`
      );
      return res.data.name || '';
    } catch {
      return '';
    }
  },
};
